import React from 'react';
import Typography from '@material-ui/core/Typography';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import AppAnimate from "../AppAnimate/index"
import withWidth from "@material-ui/core/withWidth/withWidth";
import {connect} from "trim-redux";
import Hidden from "@material-ui/core/Hidden/Hidden";
import RayanitaLogo from '../../../files/img/rayanita-dark.png';
import Grid from "@material-ui/core/Grid/Grid";

class AuthLayout extends React.Component {
    render() {
        const children = this.props.children;

        const {classes,primary_color,logo,app_name,about} = this.props;

        return (
            <div className="authContainer">
                <div className={classes.auth_container}>
                    <AppAnimate animation='transition.slideUpIn' delay={200}>
                        <div className={classes.auth_inner} >
                            <Hidden mdDown>
                            <div style={{width:"40%",position:"absolute",height:"100%",background:"rgb(30,41,59)",display:"flex",alignItems:"center",justifyContent:"center",borderRadius:"0 20px 20px 0"}}>
                                <div style={{zIndex:10}}>
                                    <img src={RayanitaLogo} alt="Rayanita" className={classes.auth_logo}/>
                                    <Typography style={{fontSize:24,fontWeight:700,color:"#fff",marginBottom:20}}>{app_name}</Typography>
                                    <Typography style={{fontSize:22,color:"#fff"}}>{about.short_description}</Typography>
                                </div>
                                <svg viewBox="0 0 960 540" width="100%" height="100%"
                                     preserveAspectRatio="xMidYMax slice"
                                     xmlns="http://www.w3.org/2000/svg"
                                     className="absolute inset-0 opacity-2">
                                    <g fill="none" stroke="currentColor" stroke-width="100"
                                       className="text-gray-700 opacity-25 ng-tns-c135-7">
                                        <circle r="234" cx="196" cy="23"
                                                className="ng-tns-c135-7"></circle>
                                        <circle r="234" cx="790" cy="491"
                                                className="ng-tns-c135-7"></circle>
                                    </g>
                                </svg>
                                <svg viewBox="0 0 220 192" width="220" height="192" fill="none"
                                     className="absolute opacity-4" style={{top:16,right:16}}>
                                    <defs>
                                        <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20"
                                                 height="20" patternUnits="userSpaceOnUse" className="ng-tns-c135-7">
                                            <rect x="0" y="0" width="4" height="4" fill="currentColor"
                                                  className="ng-tns-c135-7"></rect>
                                        </pattern>
                                    </defs>
                                    <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"
                                          className="ng-tns-c135-7"></rect>
                                </svg>
                            </div>
                            </Hidden>

                            <div className={classes.auth_container_items}>
                                <Grid container spacing={2} justify='center' alignItems="center">
                                    {children}
                                </Grid>

                            </div>
                        </div>
                    </AppAnimate>
                </div>
            </div>
        );

    }
}
const mstp = state => ({
    primary_color: state.primary_color,
    logo: state.logo,
    app_name: state.app_name,
    about: state.about,
});
export default withWidth()(withStyles(Styles)(withRouter(connect(mstp)(AuthLayout))));